import { scaleImage } from '@/utils/frontend';
import { Group, Node } from '../models';
import type { Shape, Text, Image } from '../models/shapes';
import { Action } from './';

type NodesSaveActionObjects = { nodes: Node[] };
type NodesSaveActionArgs = [boardId?: string, version?: number];
export class NodesSaveAction extends Action<NodesSaveActionObjects, NodesSaveActionArgs> {
  static actionName = 'NodesSaveAction';

  async redo({ nodes }: NodesSaveActionObjects, boardId?: string, version?: number) {
    console.log('version', version);
    const store = async (nodes: Node[]) => {
      if (!version) {
        nodes.forEach((node) => {
          if (node.type !== 'Group') {
            const n = node as Shape;

            //Only set "filled" for non-filled in shapes
            const openShapes = ['LineSegment', 'FreeLine', 'Line'];
            if (!openShapes.includes(node.type)) {
              n.filled = !(n.fillColor === 'none' || !n.fillColor);
            }
          }
        });
      }

      await nodes.reduce(async (promise, n) => {
        await promise;

        if (n.type === 'Image') {
          // Scale down images
          (n as Image).src = await scaleImage((n as Image).src);
        }

        if (boardId) {
          n.boardId = boardId;
        }

        if (n.type === 'Text' && (n as Text).fontFamily === 'times -new -roman') {
          (n as Text).fontFamily = 'Times New Roman';
        }

        this.create(n);

        if (n.type === 'Group') {
          await store((n as Group).nodes);
        }
      }, Promise.resolve());
    };

    return store(nodes);
  }
}
